/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActivateSignatureApproverDto } from './ActivateSignatureApproverDto';
import type { ActivateSignatureDocumentDto } from './ActivateSignatureDocumentDto';
import type { ActivateSignatureSignerDto } from './ActivateSignatureSignerDto';
import type { ReminderSettingsV1Dto } from './ReminderSettingsV1Dto';
import type { SignatureLabelDto } from './SignatureLabelDto';
export type ActivateSignatureResponseV1Dto = {
  /**
   * UUID of signature request
   */
  id: string;
  /**
   * Status of the signer
   */
  status: ActivateSignatureResponseV1Dto.status;
  /**
   * Name (1-128 chars)
   */
  name: string;
  /**
   * Delivery mode
   */
  delivery_mode: ActivateSignatureResponseV1Dto.delivery_mode;
  /**
   * Created at
   */
  created_at: string;
  /**
   * Ordered signers
   */
  ordered_signers: boolean;
  /**
   * Ordered approvers
   */
  ordered_approvers: boolean;
  reminder_settings: ReminderSettingsV1Dto | null;
  /**
   * Email custom note
   */
  email_custom_note: string | null;
  /**
   * Expiration date
   */
  expiration_date: string;
  signers: Array<ActivateSignatureSignerDto>;
  approvers?: Array<ActivateSignatureApproverDto>;
  labels?: Array<SignatureLabelDto>;
  documents: Array<ActivateSignatureDocumentDto>;
};
export namespace ActivateSignatureResponseV1Dto {
  /**
   * Status of the signer
   */
  export enum status {
    ONGOING = 'ongoing',
    APPROVAL = 'approval',
  }
  /**
   * Delivery mode
   */
  export enum delivery_mode {
    EMAIL = 'email',
    NONE = 'none',
  }
}
